import styled from "styled-components";

import Screens from "screens";

export default styled.div`
  padding: 3vw 6vw 3vw 6vw;

  ul {
    list-style-type: none !important;
  }
  .table {
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
  .column {
    @media ${Screens.desktop}, ${Screens.largeScreen} {
      &:first-child {
        margin-right: 20px;
        margin-left: -5px;
      }
    }
    @media ${Screens.mobile}, ${Screens.tablet} {
      &:first-child {
        margin-top: 20px;
      }
      &:nth-child(2) {
        margin-bottom: 20px;
      }
    }
    &:nth-child(2) {
      padding: 0;
    }
  }
`;
